import { TabPanel } from "@mui/lab";
import { Container } from "@mui/material";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import useClientContext from "../../../../context/useClientContext";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import PageTabs from "../../../common/PageTabs";
import ActivityLogExport from "./export/ActivityLogExport";
import ActivityLogView from "./viewer/ActivityLogView";

const tabValues = ["log", "export"] as const;

const ActivityLogPage = () => {
  const { isPortalFeatureEnabled } = useClientContext();

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  const showViewer = isPortalFeatureEnabled("ActivityLogViewEnabled");

  if (showViewer) {
    return (
      <>
        <GeneralPageHeader title="Activity Log" hideBorderLine />

        <PageTabs tabs={tabValues} labels={["Log", "Export"]} value={selectedTab} onChange={onTabChange}>
          <TabPanel value="log" sx={{ height: "100%", py: 2.5 }}>
            <Container maxWidth={false} sx={{ height: "100%" }}>
              <ActivityLogView />
            </Container>
          </TabPanel>
          <TabPanel value="export" sx={{ height: "100%", py: 2.5 }}>
            <Container maxWidth="md">
              <ActivityLogExport />
            </Container>
          </TabPanel>
        </PageTabs>
      </>
    );
  }

  return (
    <>
      <GeneralPageHeader title="Activity Log" />

      <Container maxWidth="md" sx={{ py: 2.5 }}>
        <ActivityLogExport />
      </Container>
    </>
  );
};

export default ActivityLogPage;
